<div class="container">
  <div class="row align-items-start header">
  </div>
  <div class="row align-items-center content">
    <div class="col box">
      <ng-container [ngSwitch]="alertType">
        <span *ngSwitchCase="information" class="material-icons bg-color-info">
          info
        </span>
        <span *ngSwitchCase="confirmation" class="material-icons bg-color-help">
          help
        </span>
        <span *ngSwitchCase="error" class="material-icons bg-color-error">
          error
        </span>
      </ng-container>

      <span [innerHTML]="modalMessage"></span>
    </div>
  </div>

  <div class="row modal-actions">
    <div class="modal-footer d-table w-100">
      <div class="d-table-cell">
        <button tabindex="-1" *ngIf="isConfirmation" mat-stroked-button class="currentBtn" (click)="onConfirm(false)">{{cancelActionName}}</button>
      </div>
      <div class="d-table-cell tar">
        <button tabindex="-1" class="btn btn-secondary" mat-stroked-button class="currentBtnColor" (click)="onConfirm(true)">{{validateActionName}}</button>
      </div>
    </div>
  </div>
</div>
